import { CSSProperties, useCallback } from 'react';
import { allFonts } from 'apps/cdp-web-demo/app/data/fonts';
import { ConfigFormHandlers, FontFamily } from 'apps/cdp-web-demo/app/types';
import { Select } from '@cbhq/cds-web/controls/Select';
import { SelectOption } from '@cbhq/cds-web/controls/SelectOption';
import { VStack } from '@cbhq/cds-web/layout';
import { Text } from '@cbhq/cds-web/typography';

import styles from './FontFamilyField.module.css';

type Props = {
  fontFamily: FontFamily;
  setFontFamily: ConfigFormHandlers['setFontFamily'];
};

const fontFamilyOptions: { label: string; value: FontFamily; style: CSSProperties }[] = [
  {
    label: 'Rethink Sans (Default)',
    value: 'rethinkSans',
    style: { fontFamily: allFonts.rethinkSans.style.fontFamily },
  },
  {
    label: 'Inter',
    value: 'inter',
    style: { fontFamily: allFonts.inter.style.fontFamily },
  },
  {
    label: 'Open Sans',
    value: 'openSans',
    style: { fontFamily: allFonts.openSans.style.fontFamily },
  },
  {
    label: 'Source Code Pro',
    value: 'sourceCodePro',
    style: { fontFamily: allFonts.sourceCodePro.style.fontFamily },
  },
];

function FontFamilyField({ fontFamily, setFontFamily }: Props) {
  const handleFontFamilyChange = useCallback(
    (value: string) => {
      setFontFamily(value as FontFamily);
    },
    [setFontFamily],
  );

  return (
    <VStack gap={0.5} className={styles['font-family-field']}>
      <Text font="label1" display="block" paddingY={0.5}>
        Font
      </Text>
      <Select
        value={fontFamily}
        valueLabel={fontFamilyOptions.find((option) => option.value === fontFamily)?.label}
        placeholder="Choose a font..."
        onChange={handleFontFamilyChange}
        compact
        disablePortal
      >
        {fontFamilyOptions.map((option) => (
          <SelectOption
            value={option.value}
            key={option.value}
            title={
              <Text font="label1" style={option.style}>
                {option.label}
              </Text>
            }
          />
        ))}
      </Select>
    </VStack>
  );
}

export { FontFamilyField };
